module.exports = __webpack_public_path__ + "img/20190904.560f5dac.png";